module.exports = __webpack_public_path__ + "static/7-img-1-9270b151a0260c13f32859ed627ba819.png";